var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.714355 12.5028H13.2858M4.14293 3.93136H9.85721M4.14293 6.7885H9.85721M4.14293 9.64565H7.5715M12.1429 1.07422H1.85721C1.22604 1.07422 0.714355 1.58589 0.714355 2.21708V14.7885C0.714355 15.4197 1.22604 15.9314 1.85721 15.9314H12.1429C12.7741 15.9314 13.2858 15.4197 13.2858 14.7885V2.21708C13.2858 1.58589 12.7741 1.07422 12.1429 1.07422Z",
    stroke: "#AA1A5F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogButton);
export default __webpack_public_path__ + "static/media/logButton.92fb5246e8eff3f89832ca30aa4d89fd.svg";
export { ForwardRef as ReactComponent };